
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/[merchantLocationId]/t/[tableId]",
      function () {
        return require("private-next-pages/m/[merchantLocationId]/t/[tableId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/[merchantLocationId]/t/[tableId]"])
      });
    }
  